"use strict";
/**
 * Snapshot Domain Database Types
 *
 * The per-publish immutable content reference for patterns and projects only.
 * These types represent the actual DynamoDB records as written by lambda-utilities.
 */
Object.defineProperty(exports, "__esModule", { value: true });
